export const ACCEPTANCE_COEFFICIENTS_REPORT_DEV =
  '/api/v1/supply/acceptanceCoefficientsReport';
export const getAcceptanceCoefficientsReportEndpointProd = () =>
  window.ENDPOINT_ACCEPTANCE_COEFFICIENTS_REPORT;
